// import { toast } from 'react-toastify';
import toast from '../components/Toastify';
import { takeEvery, call, put, fork } from 'redux-saga/effects';
import { load, loaded } from 'ducks/loading';
import * as api from '../services/api';
import * as actions from '../ducks/reviews';

function* getReviews(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/reviews/get', action.data);
    if (res.status == 'success') {
      yield put(actions.successReviewData(res.data));
    }
    yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* updateReview(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/reviews/updateReview', action.data);
    if (res.status == 'success') {
      //yield put(actions.successReviewData(res.data));
      toast.success(res.m);
    }
    yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* deleteReviewData(action) {
  try {
    yield put(load());
    const res = yield call(api.DELETE, '/reviews/deleteReviewData?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.successReviewData(res.data));
      yield toast.info(res.m);
    }
    yield put(loaded());
  }
  catch (error) {
    // yield put(actions.userLoginError(true));
  }
}

function* deleteBulkReview(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/reviews/deleteBulkReview', action.data);
    if (res.status == 'success') {
      yield put(actions.successReviewData(res.data));
      toast.success(res.m);
    }
    yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

//get user integration for search datasource
function* getUserIntegration(action) {
  try {
    // yield put(load());
    const res = yield call(api.GET, '/master/getUserIntegration?type=' + action.data.type);
    if (res.status == 'success') {
      yield put(actions.successGetUserIntegration(res.data));
    }
    else if (res.status == 'fail') {
      toast.error(res.m);
    }
    // yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

export function* watch() {
  yield takeEvery(actions.GET_REVIEW_DATA, getReviews);
  yield takeEvery(actions.UPDATE_REVIEW_DATA, updateReview);
  yield takeEvery(actions.DELETE_REVIEW, deleteReviewData);
  yield takeEvery(actions.DELETE_BULK_REVIEW_DATA, deleteBulkReview);
  yield takeEvery(actions.GET_USER_INTEGRATION, getUserIntegration);
}

export default function* rootSaga() {
  yield [
    fork(watch)
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/reviews.js